import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { ZapCard } from '../ZapCard/ZapCard.es.js';
import '../ZapCard/ZapCardDetails.es.js';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';

const zapcardSection = "_zapcard-section_10iwx_1";
const styles = {
	zapcardSection: zapcardSection
};

const breakpoints = {
  tablet: 768,
  desktop: 1230
};
const Styles = labelStyles("ZapCardSection", {
  root: css`
    padding: 20px;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      padding: 20px 30px;
    }

    @media screen and (min-width: ${breakpoints.desktop}px) {
      padding: 40px;
    }
  `,
  container: (layout) => css`
    display: grid;
    gap: 30px;
    grid-template-columns: ${layout === "auto" ? "1fr" : "repeat(auto-fit, minmax(235px, 1fr))"};
    margin: 0 auto;
    max-width: 1170px;
  `
});
const ZapCardSection = ({ items, layout = "card" }) => {
  var _a;
  if (items.length > 3 && layout !== "auto") {
    console.error("Max 3 items are allowed in ZapCardSection component");
  }
  const maxItems = layout === "auto" ? items.length : 3;
  return jsx(
    "div",
    { css: Styles.root, className: styles.zapcardSection, "data-zds": true },
    jsx("div", { css: Styles.container(layout), "data-zds": true }, (_a = items === null || items === void 0 ? void 0 : items.slice(0, maxItems)) === null || _a === void 0 ? void 0 : _a.map((_a2) => {
      var { color = Colors.neutral100, href } = _a2, rest = __rest(_a2, ["color", "href"]);
      return jsx(ZapCard, Object.assign({}, rest, { color, href, layout }));
    }))
  );
};

export { ZapCardSection };
//# sourceMappingURL=ZapCardSection.es.js.map
